import { ActionTypes } from 'modules/jobManager/ducks/actionTypes';
import { JobAction, JobTableData, JobTableDataState } from 'modules/jobManager/types';

export const initialJobTableDataState: JobTableDataState = {
  items: [],
  loading: false,
  error: false,
};

export const jobTableDataReducer = (state = initialJobTableDataState, action?: JobAction) => {
  switch (action?.type) {
    case ActionTypes.FETCH_TABLE_DATA_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };

    case ActionTypes.FETCH_TABLE_DATA_RESPONSE: {
      const { results } = action?.payload as JobTableData;
      const items = results || state.items;

      return {
        items,
        error: false,
        loading: false,
      };
    }

    case ActionTypes.FETCH_TABLE_DATA_ERROR:
      return {
        ...state,
        error: true,
        loading: false,
      };
    default:
      return state;
  }
};
